export enum MarketCode {
  USA = "USA",
  CAN = "CAN",
  FRA = "FRA",
  GER = "GER",
  DEU = "DEU",
  GBR = "GBR",
}
